import { user_click_item_header } from 'store/actions';
import { Store } from 'store/store';
import { SUSPECTS } from '../constants';
import Boxes from './Boxes';

const Suspects = () => {
  const dispatch = Store.useDispatch();

  return (
    <>
      <div className="grid-item grid-hr">Suspects</div>

      {SUSPECTS.map(({ name, color }) => [
        // Suspect Header
        <div
          key={name}
          className="grid-item"
          style={{ backgroundColor: color }}
          onClick={() => dispatch(user_click_item_header(name))}
        >
          {name}
        </div>,

        // Boxes
        <Boxes key={name + '-boxes'} name={name} />,
      ])}
    </>
  );
};

export default Suspects;
